<template>
    <div>
        <div class="s_tl">
            <span class="left">
                <a href="/">首页</a>
                <code class="lr3">&#62;</code>
                <a href="javascript:;" @click="catesearch(tableData.pcate,index)">{{tableData.pcate}}</a>
                <code class="lr3">&#62;</code>
            </span>
            <ul class="left s_sx">
                <li>
                    <div v-for="(soncate,index) in tableData.soncate" :key="index">
                        <a class="d_xx" href="javascript:;">分类：{{soncate.title}}</a>
                    </div>
                    
                </li>
            </ul>
            <div class="right">共找<b class="c3">{{tableData.total}}</b>件</div>
        </div>
        <div class="scat over">
            <dl class="sdl sfst">
                <dt><b class="red">分类</b></dt>
                <dd>
                    <div v-for="(cate,index) in tableData.cate" :key="index">
                        <router-link :to="{path:'/shop/shopsearch', query:{cate_id:cate.id}}" target="_blank" class="sd_aa f14">
                            {{cate.title}}
                        </router-link>
                    </div>
                </dd>
            </dl>
        </div>
        <div class="sxbox">
            <div class="ls_cat" id="ls_cat">
                <div class="w">
                    <div class="left pl10">
                        <a rel="nofollow" href="javascript:;" class="sb_a " @click="getPrice('综合')" :class="{sb_on:tableFrom.order_sn==''}">综合</a>
                        <a rel="nofollow" href="javascript:;" class="sb_a" @click="getPrice('销量')" :class="{sb_on:tableFrom.order_sn=='invent_sale_desc'}">销量</a>
                        <a rel="nofollow" href="javascript:;" class="sb_a" @click="getPrice" :class="[tableFrom.order_sn=='price_asc' || tableFrom.order_sn=='price_desc'?'sb_on ':'']"><em class="pr10">价格</em><i class="rjg"></i></a>
                        <!-- <div class="cx_box left" id="cx_box">
                            <input type="text" class="lj_ipt" value="" title="最低价" placeholder="最低价" id="min_price"><em class="left mt10 mr5">-</em>
                            <input type="text" class="lj_ipt" value="" title="最高价" placeholder="最高价" id="max_price">
                        <p class="lj_ok"><em class="lj_btn" onclick="do_sx(1)">确定</em></p>
                        </div>
                        <label class="ls_lab"><a href="javascript:;" class="c9"><input type="checkbox" value="0" name="discount" class="mr5">新品</a></label>
                        <label class="ls_lab"><a href="javascript:;" class="c9"><input type="checkbox" value="0" name="discount" class="mr5">折扣</a></label>
                        <label class="ls_lab"><a href="javascript:;" class="c9"><input type="checkbox" value="0" name="video" class="mr5">视频</a></label>
                        <label class="ls_lab"><a href="javascript:;" class="c9"><input type="checkbox" value="0" name="pc_video" class="mr5">评测</a></label> -->
                    </div>
                    <!-- <div class="prt right"> 
                        <span class="left mr10" id="page_nmx">1/3</span>
                        <a class="pr_a p_off" href="javascript:;" id="tprev">上一页</a> 
                        <a class="pr_a" href="javascript:;" id="tpnxt">下一页</a>
                    </div> -->
                </div>
            </div>
        </div>
        <p id="loading" class="lding hid"><em class="lod_ico">加载中,请稍候....</em></p>
        <div class="gdls" id="gdls">
            <dl class="gl" v-for="(item,index) in tableData.data" :key="index"  @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)">
                <dt>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank">
                        <img :src="item.piclink" width="270" height="270" class="sbm" alt="">
                    </router-link>
                </dt>
                <!-- <dd class="simg">
                    <img src="https://s.cccgx.com/t/26x26/images/qu/10631/gallery/20210624034435_93941.jpg" width="26" height="26" class="ss_m">
                </dd> -->
                <dd>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="gna pt10">
                        {{item.title}}
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="pt_g mt5">
                        <em class="p_tag">{{item.sub_title}}</em>
                    </router-link>
                </dd>
                <dd class="gp_d">
                    <i class="rmb left">¥</i>
                    <b class="xj left">{{item.price}}</b>
                    <em class="cs_o">已售{{item.sale}}件</em>
                </dd>
                <dd class="pt5">
                    <em class="i_hot">热销</em>
                    <!-- <em class="i_video">视频</em> -->
                    <i class="i_by">包邮</i>
                    <i class="i_hot" v-if="item.label">{{item.label}}</i>
                </dd>
            </dl>
        </div>
        <div class="page" id="pager">
            <el-pagination :page-sizes="[20, 40, 60, 80]" :page-size="tableFrom.limit" :current-page="tableFrom.page" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total" @size-change="handleSizeChange" @current-change="pageChange" />
        </div>
         <!-- <pagination :total="pagination.total"
            :current="pagination.currentPage"
            :pageSize="pagination.pageSize"
            :pageSizeOpts="pagination.pageSizeList"
            @pagechange="pageChagne($event)"
            @page-size-change="pageChagne($event,'size')"
        ></pagination> -->
    </div>
</template>

<script>
import qs from 'qs'
import Paginations from "@/components/common/paginate.vue"
export default {
    components:{
        "paginations":Paginations
    },
    data(){
        return{
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                order_sn: this.$route.query.order_sn ? this.$route.query.order_sn : "",
                keywords: "",
                page: 1,
                limit: 20,
                type: "1",
                title: "",
                sid_cn: "",
                cate_id: this.$route.query.cate_id ? this.$route.query.cate_id : "",
            },
            isActive:false,
            
        }
    },
    mounted() {
        this.getList(1);
        this.getSearchCateProduct(this.$route.query.cate_id);
    },
    methods:{
        //获取所有子分类热销产品
        getSearchCateProduct(cate_id) {
            var that = this;
            var params = {};
            params.cate_id = cate_id || "";
            this.dialogVisible = true;
            this.LogLoading = true;
            that.$api.getShop.getSearchCateProduct(params, this.tableFrom).then(res => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.cate = res.result.cate;
                    this.tableData.pcate = res.result.pcate;
                    this.tableData.soncate = res.result.soncate;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                }
            }).catch((res) => {
                    this.$message.error(res.message);
                    this.listLoading = false;
                });
        },
        // 列表
        getList(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getShop.getSearchCateProduct(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.tableData.cate = res.result.cate;
                    this.tableData.pcate = res.result.pcate;
                    this.tableData.soncate = res.result.soncate;
                    this.tableData.cate_id = this.$route.query.cate_id;
                    this.listLoading = false;
                    console.log(this.tableData)
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="gl hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="gl";
        },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 2){
                this.$router.push(`/biyuntao/`);
            }else if(index == 3){
                this.$router.push(`/zhuxing/`);
            }else if(index == 4){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 5){
                this.$router.push(`/tehui/`);
            }
        },
        getPrice (str) {
            if (str == '综合') {
                this.tableFrom.order_sn = ''
            } else if (str == '销量') {
                this.tableFrom.order_sn = 'invent_sale_desc'
            } else if (this.tableFrom.order_sn == 'price_asc') {
                this.tableFrom.order_sn = 'price_desc'
            } else {
                this.tableFrom.order_sn = 'price_asc'
            }
            this.$emit("setSearch", this.tableFrom);
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shop/shopsearch/shopsearchlist.vue